import React from 'react';

export type Theme = 'light' | 'dark';
export const OPPOSITE_THEMES: Record<Theme, Theme> = {
  light: 'dark',
  dark: 'light',
};

export interface IThemeContext {
  theme: Theme;
  selectTheme: (t: Theme) => void;
  toggleTheme: () => void;
}

export const ThemeContext = React.createContext<IThemeContext | undefined>(undefined);
